import { render, staticRenderFns } from "./Home-Requests.vue?vue&type=template&id=2a3763cd&scoped=true&"
import script from "./Home-Requests.vue?vue&type=script&lang=js&"
export * from "./Home-Requests.vue?vue&type=script&lang=js&"
import style0 from "./Home-Requests.vue?vue&type=style&index=0&id=2a3763cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3763cd",
  null
  
)

export default component.exports